import React, {useEffect} from 'react';
import {Container} from 'react-bootstrap';
import Widgets from './Widgets';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import {messaging} from '../../../src/firebase';
import {getToken} from 'firebase/messaging';
import ApiUtils from 'api/ApiUtils';

const Dashboard = (): React.JSX.Element => {
  document.title = DOCUMENT_TITLE.DASHBOARD_TITLE;

  async function requestPermission(): Promise<void> {
    // requesting permission using Notification API
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: process.env.VITE_APP_VAPID_KEY,
      });

      await ApiUtils.updateDeviceToken({device_token: token});

      // We can send token to server
    } else if (permission === 'denied') {
      // notifications are blocked
      alert('You denied for the notification');
    }
  }

  useEffect(() => {
    void requestPermission();
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Dashboard</h4>
        </div>
        <Widgets />
        {/* <RecentOrders /> */}
      </Container>
    </div>
  );
};

export default Dashboard;
